import {useABTest} from "@pg-mono/ab-testing";

import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {OPEN_PRICES_VARIANT, openPricesAbTests} from "../open_prices_ab_tests";

export const useOpenPricesExperiment = () => {
    const isAuthenticated = useIsAuthenticated();
    const {canABTestBeRendered: canUseOpenPricesExperiment, abTestVariant} = useABTest({
        id: openPricesAbTests.id,
        variants: openPricesAbTests.variants,
        withSSR: openPricesAbTests.withSSR,
        pushEventOnlyOnce: true
    });
    const isOpenPricesVariant = canUseOpenPricesExperiment && abTestVariant === OPEN_PRICES_VARIANT;

    return {
        isOpenPricesVariant,
        isAnonymousOpenPricesEnabled: isOpenPricesVariant && !isAuthenticated,
        variant: canUseOpenPricesExperiment ? abTestVariant : null
    };
};
import {useABTest} from "@pg-mono/ab-testing";

import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";
import {OPEN_PRICES_VARIANT, openPricesAbTests} from "../open_prices_ab_tests";

export const useOpenPricesExperiment = () => {
    const isAuthenticated = useIsAuthenticated();
    const {canABTestBeRendered: canUseOpenPricesExperiment, abTestVariant} = useABTest({
        id: openPricesAbTests.id,
        variants: openPricesAbTests.variants,
        withSSR: openPricesAbTests.withSSR,
        pushEventOnlyOnce: true
    });
    const isOpenPricesVariant = canUseOpenPricesExperiment && abTestVariant === OPEN_PRICES_VARIANT;

    return {
        isOpenPricesVariant,
        isAnonymousOpenPricesEnabled: isOpenPricesVariant && !isAuthenticated,
        variant: canUseOpenPricesExperiment ? abTestVariant : null
    };
};
